<p-breadcrumb [model]="routePath"></p-breadcrumb>
<div appAccessProvider [accessCode]="{ menuCode: 'PRODUCTS', pageCode: 'ALL', subPageCode: 'VIEW' }"
    class="product-details">
    <div class="grid mt-1 details-div border-bottom-1 border-200 mr-0 product-details-header">
        <div class="col-9 md:col-10 details-header-spacing">
            @if (showStatus) {
            <app-status [dataForVehicleStatus]="dataForVehicleStatus" [userId]="userId"
                [entityForStatus]="entityForStatus" [imgFileUrl]="" [imgFileId]="" [showImage]="false"></app-status>
            }
        </div>
        <div appAccessProvider [accessCode]="{ menuCode: 'PRODUCTS', pageCode: 'ALL', subPageCode: 'EDIT' }"
            class="col-2 flex align-items-center justify-content-end">
            @if (isDeleted && !isDeletedProduct) {
            <button (click)="edit()" pButton
                class="edit-btn border-400 bg-white text-color hover:surface-100 whitespace-nowrap"
                [label]="editBtnLabel">
                <i class="mi-lg mr-2 edit-pen edit_pencil wh-16"></i>
            </button>
            }
        </div>
    </div>
    <p-tabView [(activeIndex)]="activeIndex" [scrollable]="true" (activeIndexChange)="activeIndexChange($event)"
        [scrollable]="true" class="vehicle-detail-tab">
        <p-tabPanel>
            <ng-template pTemplate="header">
                <i class="mi-lg overview"></i>
                <label class="capitalize" translate>product.lbl_overview</label>
            </ng-template>
            @if (productDetails) {
            <app-product-overview-details
                [attributeValues]="attributeValues"
                [attributeLabels]="attributeLabels"
                [packTypeValue]="packTypeValue"
                [storageValue]="storageValue"
                [productAttributeData]="productAttributeData"
                [productEntityId]="productId"
                [productRowData]="currentRow"
                [productDetails]="productDetails"
                [isDeleted]="isDeleted && !isDeletedProduct"
                [isUnassigned]="isUnassigned"></app-product-overview-details>
            }
        </p-tabPanel>
    </p-tabView>
</div>